import { PlanDetailsSection, PlanType } from '../../curriculum';

type BasicPlusFeature = {
  name: string;
  type: PlanType;
};

export function buildBasicPlusFeaturesFromSections(sections: PlanDetailsSection[]): BasicPlusFeature[] {
  if (!Array.isArray(sections) || sections.length === 0) return [];

  const basicSection = sections.find(s => /basic/i.test(s.title));
  const plusSection = sections.find(s => /plus/i.test(s.title));

  const basicContents = normalizeContents(basicSection?.contents);
  const plusContents = normalizeContents(plusSection?.contents);

  if (basicContents.length === 0 && plusContents.length === 0)
    return sections[0].contents.map(name => ({ name, type: 'basic' }));

  return buildBasicPlusFeatures(basicContents, plusContents);
}

function buildBasicPlusFeatures(basicContents: string[] = [], plusContents: string[] = []): BasicPlusFeature[] {
  const basicSet = new Set(basicContents);

  return [
    ...basicContents.map(name => ({ name, type: 'basic' as const })),
    ...plusContents.filter(name => !basicSet.has(name)).map(name => ({ name, type: 'plus' as const })),
  ];
}

function normalizeContents(contents?: string[]): string[] {
  if (!Array.isArray(contents)) return [];
  return contents.map(c => (typeof c === 'string' ? c.trim() : '')).filter(Boolean);
}
